import { jsx as d } from "react/jsx-runtime";
import { classes as i } from "../../utils/styles.js";
import o from "./label.module.js";
const p = ({
  children: r,
  variant: e = "filled",
  color: l = "rgb(248, 104, 0)",
  textColor: s = e === "outlined" ? l : "white",
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: i([o.label, o[e]]),
    style: {
      backgroundColor: e === "filled" ? l : "transparent",
      color: e === "filled" ? "white" : s,
      ...e === "outlined" && { borderColor: l }
    },
    ...t,
    children: r
  }
);
export {
  p as Label
};
